import { Observable, OperatorFunction } from 'rxjs';
import { debounceTime, skip, switchMap, takeUntil } from 'rxjs/operators';

export function autocomplete(time: number, selector: (...args: any[]) => Observable<any>): OperatorFunction<any, any> {
    return (source: Observable<any>) =>
        source.pipe(
            debounceTime(time),
            switchMap((...args: any[]) => selector(...args).pipe(takeUntil(source.pipe(skip(1)))))
        );
}
